function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { RECEIVE_RECENT_TRADES, REQUEST_RECENT_TRADES, RECEIVE_RECENT_TRADES_ERROR, ADD_RECENT_TRADE } from '../actions/recentTradesActions';

/**
 * state of format:
 * {
 *    [instrumentId1]: [],
 *    [instrumentId2]: [],
 * }
 */
var initalState = {
  fetching: true
};
export default function recentTrades() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
  var action = arguments[1];
  var payload = action.payload,
    type = action.type;
  switch (type) {
    case RECEIVE_RECENT_TRADES:
      return handleReceiveRecentTrades(state, payload);
    case REQUEST_RECENT_TRADES:
      return Object.assign({}, state, {
        fetching: true
      });
    case RECEIVE_RECENT_TRADES_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        error: payload
      });
    case ADD_RECENT_TRADE:
      return handleAddRecentTrades(state, payload);
    default:
      return state;
  }
}
var handleReceiveRecentTrades = function handleReceiveRecentTrades(state, _ref) {
  var instrumentId = _ref.instrumentId,
    data = _ref.data;
  return Object.assign({}, state, _defineProperty({
    fetching: false
  }, instrumentId, data.reverse()));
};
var handleAddRecentTrades = function handleAddRecentTrades(state, _ref2) {
  var instrumentId = _ref2.instrumentId,
    data = _ref2.data;
  var prevValue = state[instrumentId];
  var prevState = prevValue ? prevValue.slice(0, -data.length) : [];
  var newState = [].concat(_toConsumableArray(data), _toConsumableArray(prevState));
  return Object.assign({}, state, _defineProperty({}, instrumentId, newState));
};